import { BASE_COLORS, WINNERS_2023_MAPPING } from 'client/site-modules/shared/constants/top-rated/top-rated';
import { isEmpty } from 'lodash-es';

export const topRatedHelpers = {
  isDarkTheme: theme => theme === 'dark-theme',
  isLightTheme: theme => theme === 'light-theme',
  swapTextColor: (baseColor, year, overrideColor = '') => {
    /*
     * baseColor is color from 2021, the first year of Top Rated
     * If feature flag is not enabled, the yearKey will default to '2021'
     * Feature flag should be cleaned up after prod release.
     *
     * override color: set to empty string as default unless there is a special case
     * where override color is necessary.
     *
     */
    if (overrideColor) {
      return overrideColor;
    }
    return BASE_COLORS[baseColor][year];
  },
  toggleBodyModalClass: (theme, addClass) => {
    const body = document.querySelector('body');
    const isLightTheme = topRatedHelpers.isLightTheme(theme);
    if (isLightTheme) {
      const topRatedModalOpenClass = 'darken-modal';
      if (addClass) {
        body.classList.add(topRatedModalOpenClass);
      } else {
        body.classList.remove(topRatedModalOpenClass);
      }
    }
  },

  mapWinners2023: (winners, pagePaths) => {
    const pathToUse = pagePaths || WINNERS_2023_MAPPING;
    const map = pathToUse.reduce((acc, cur) => {
      const match =
        winners &&
        winners.find(winner => {
          const tileURL = winner.metadata('tileURL').value();
          return tileURL.includes(cur);
        });
      if (match) {
        acc.push(match);
      }
      return acc;
    }, []);
    return map;
  },

  mapWinners2023ArticlePage: (winners, pathname, pagePaths) => {
    const sorted = topRatedHelpers.mapWinners2023(winners, pagePaths);

    const map =
      sorted &&
      sorted.slice(1).map(winner => {
        if (winner && winner.metadata('tileURL').value() === pathname) {
          return sorted[0];
        }
        return winner;
      });
    return map;
  },

  get2023IconSize: (index, isOddNumLength, isTruckCategory) => {
    if (index === 0 && isOddNumLength) {
      return {
        width: '150px',
        height: '50px',
      };
    }

    if (isTruckCategory) {
      return {
        width: '102px',
        height: '38px',
      };
    }

    return {
      width: '94px',
      height: '38px',
    };
  },

  get2026IconSize: (index, isOddNumLength, isTruckCategory) => {
    if (index === 0 && isOddNumLength) {
      return {
        width: '170px',
        height: '120px',
      };
    }

    if (isTruckCategory) {
      return {
        width: '102px',
        height: '56px',
      };
    }

    return {
      width: '100px',
      height: '58px',
    };
  },

  getGradientClass: type => {
    if (type && type.includes('electric')) {
      return 'electric';
    }
    return type;
  },

  getPagePathFromConfigData: configData =>
    configData &&
    !isEmpty(configData.child('pagePaths').childEntries) &&
    configData.child('pagePaths').childEntries.map(entry => entry.id),
};
